<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
        <div class="modal-header">{{header}}</div>
        <div class="modal-body">
            <div class="table" *ngIf="dataBodyTable">
                <frg-table #annTable [keysBody]="dataBodyTable" [keysColumn]="dataColumnTable" [isRowsClickable]="true"
                    (onClickRow)="selectedValue($event)" (onChangePage)="changePage($event)" [loading]="isLoadingTable"></frg-table>
            </div>
            <div class="button-wrapper">
                <frg-button (activated)="closeSelectList()" [backgroundColor]="'var(--darkest-primary)'"
                    [type]="'reset'">Retour</frg-button>
                <frg-button (click)="sendValueSelected()" [type]="'submit'" [backgroundColor]="'var(--primary)'">{{ validButtonLabel }}
                </frg-button>
            </div>
        </div>
    </div>
</div>
<div class="modal-background"></div>